import Resources from './resources';

/**
 *  utitlity functions
 */

export function handleDefaults(defaultObj, dynamicObj) {
  for (const key in dynamicObj) {
    defaultObj[key] = dynamicObj[key];
  }
  return defaultObj;
}

export function getConfiguration(name) {
  if (window.pppAppConfig) {
    return window.pppAppConfig[name];
  }

  return '';
}

export function log() { }

export function getContextCoords(position, modalWidth, contextPos) {
  const leftOffset = (position.left || position.x || position.clientX);
  const innerOffsetRight = ((window.innerWidth) - (position.right || position.clientX));
  const innerOffsetLeft = leftOffset - modalWidth;
  const coords = {};

  switch (contextPos) {
    case 'right':
      coords.posY = (position.bottom || position.clientY) - 35;
      coords.posArrow = leftOffset + position.width;
      coords.posX = coords.posArrow + 10;
      break;
    default:
      coords.posY = (position.bottom || position.clientY) + 5;
      coords.posArrow = leftOffset + ((position.width || 2) / 2);
      if (innerOffsetRight > modalWidth && innerOffsetLeft > modalWidth) {
        coords.posX = (coords.posArrow - (modalWidth / 2)); // center aligned
      } else if (innerOffsetLeft < modalWidth && innerOffsetRight > modalWidth) {
        coords.posX = (coords.posArrow - 15); // left aligned
      } else {
        coords.posX = ((coords.posArrow - modalWidth) + 15); // right aligned
      }
  }

  return coords;
}

export const getTeacherAuthToken = () => {
  const { authToken } = Resources.env;
  return authToken;
};

/**
 *  constants
 */

export const studentStatus = {
  UNASSIGNED: 0,
  UNATTEMPTED: 1,
  ASSIGN_SELECTION: 2,
  PARTIAL: 3,
  CORRECT: 4,
  UNASSIGN_SELECTION: 6
};

export const teacherStatus = {
  SUBMITTED: 1,
  REVIEWED: 2
};

export const assignmentType = {
  RESTRICTED: 0,
  NON_RESTRICTED: 1
};

export const durationTypes = {
  PER_ASSIGNMENT: 0,
  PER_QUESTION: 1
};

export const splitPeriod = time => `${time.slice(0, time.length - 2)} ${time.slice(time.length - 2)}`;

export const MAX_STUDENT_NAME_LENGTH = 20;
export const MAX_ITEMS_TO_DISPLAY = 14;
export const MAX_GROUP_NAME_LENGTH = 20;
export const MAX_LJ_COUNT = 200;
export const DEFAULT_POLL_DELAY = 10000;
export const LOCALE_DEFAULT = 'en-AU';

export const TOP_PROBLEM_QUESTIONS_STATUS = {
  NORMAL: 0,
  NO_SPINE_TAGGING: 1,
  NO_RESULTS: 2,
  ALL_CORRECT: 3
};
